<div class="grid">

    <div class="col-12">

        <p-card header="RTPN Transactions Log" subheader="" class="ui-card-light" >

            <!--  C R I T E R I A  -->
            <div class="wal-criteria-row">

                <div class="wal-criteria-item">
                    <label for="dateFrom">Date From:</label>
                    <p-datePicker id="dateFrom" [(ngModel)]="selectedDateFrom" dateFormat="yy-mm-dd"
                        [showIcon]="true"></p-datePicker>
                </div>

                <div class="wal-criteria-item">
                    <label for="dateTo">Date To:</label>
                    <p-datePicker id="dateTo" [(ngModel)]="selectedDateTo" dateFormat="yy-mm-dd"
                        [showIcon]="true"></p-datePicker>
                </div>

                <div class="wal-criteria-item">
                    <label for="accountNumber">Account Number:</label>
                    <input pInputText id="accountNumber" type="text" [(ngModel)]="selectedAccountNumber">
                </div>

                @if(isBrandSelectionShown) {
                    <div class="wal-criteria-item">
                        <label for="billerCode">Brand Code:</label>
                        <p-select id ="billerCode" [options]="billerCodes" [(ngModel)]="selectedBrandCode"
                            (onChange)="onChangeBiller($event)" [editable]="false">
                        </p-select>
                    </div>
                }

                <div class="wal-criteria-item">
                    <label for="requestType">Request Type:</label>
                    <p-select id ="requestType" [options]="requestTypes" [(ngModel)]="selectedRequestType"
                        [editable]="false">
                    </p-select>
                </div>

                <div class="wal-criteria-item">
                    <label for="statusCode">Status Code:</label>
                    <p-select id ="statusCode" [options]="statusCodes" [(ngModel)]="selectedStatusCode"
                        [editable]="false">
                    </p-select>
                </div>

                <div class="wal-criteria-item wal-criteria-actions">
                    <p-button label="Search" styleClass="p-button-success wal-success p-button-raised p-button-rounded" (click)="onSearchClick($event)"></p-button>
                    <p-button label="Clear" styleClass="p-button-danger wal-danger p-button-raised p-button-rounded" (click)="onClearClick($event)"></p-button>
                </div>

                <div class="wal-criteria-item wal-criteria-status">
                    @if (isSpinnerHidden && clientTimezone) {
                        <span class="p-text-secondary">{{clientTimezone}}</span>
                    }
                    <div id="idSpinner" [hidden]="isSpinnerHidden">
                        <div class="loader"></div>
                    </div>
                </div>

            </div>

            <!--  G R I D  -->

            <div class="col-12">

                <p-table #dtRtpnTxn [columns]="rtpnTransactionsCols" [value]="rtpnTransactions" selectionMode="single"
                    [(selection)]="selectedRtpnTransaction" class="p-datatable-striped p-datatable-sm wal-table"
                     [rowsPerPageOptions]="[10,15,25,50]" [showCurrentPageReport]="true" dataKey="rtpnRequestId"
                    sortMode="multiple" (onRowSelect)="onRtpnTransactionRowSelect($event)" [paginator]="true" [rows]="25">
                    <ng-template pTemplate="caption">
                    Log of RTPN Transactions
                    </ng-template>
                    <ng-template pTemplate="caption">
                        <div style="text-align: right">
                            <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
                            <input type="text" pInputText size="50" placeholder="Global Filter" (input)="dtRtpnTxn.filterGlobal($any($event.target).value, 'contains')" style="width:auto">
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th style="width: 2.25em"></th>
                            @for (col of columns; track col.field) {
                                <th [pSortableColumn]="col.field"
                                    [style.display]="col.display"
                                    [style.width]="col.width">
                                    {{ col.header }}
                                    <p-sortIcon [field]="col.field"></p-sortIcon>
                                </th>
                            }
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
                        <tr [pSelectableRow]="rowData">
                        <td [ngStyle]="{'width': '3%'}">
                            <button type="button" pButton pRipple [pRowToggler]="rowData" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                        </td>
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="expandedrow" let-rowData>
                    <tr>
                        <td [attr.colspan]="4">
                        <div class="ui-g ui-fluid" style="font-size:11px;padding:7px">
                            <div class="ui-g-12 ui-md-9">
                                <div class="grid">
                                    <div class="col-12">
                                        <b>Execution Code:</b> {{rowData.exitCode}}
                                    </div>
                                    <div class="col-12">
                                        <b>Execution Message:</b> {{rowData.errorMsg}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </td>
                    </tr>
                    </ng-template>

                    <ng-template pTemplate="summary">
                        <div style="text-align:left">
                            <div class="ui-helper-clearfix">
                                <p-button label="Prior" *ngIf="isPriorButtonShown" styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="onPriorClick($event)"></p-button>
                                <p-button label="Next"  *ngIf="isNextButtonShown" styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="onNextClick($event)"></p-button>
                                <p-button styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left float-right"
                                    label="Export" (click)="onFileCreationRequest($event)" >
                                </p-button>
                            </div>
                        </div>
                    </ng-template>

                </p-table>

            </div>

            <p-footer>
                <mat-icon class="nav-caption wal-center">account_balance</mat-icon>
            </p-footer>

        </p-card>
    </div>

</div>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="rtpn-transactions"></p-confirmDialog>
